import { render, staticRenderFns } from "./SearchMovement.vue?vue&type=template&id=32db680b&scoped=true"
import script from "./SearchMovement.vue?vue&type=script&lang=ts"
export * from "./SearchMovement.vue?vue&type=script&lang=ts"
import style0 from "./SearchMovement.vue?vue&type=style&index=0&id=32db680b&prod&scoped=true&lang=css"
import style1 from "./SearchMovement.vue?vue&type=style&index=1&id=32db680b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32db680b",
  null
  
)

export default component.exports